if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const frameSelects = this.getFrameSelects();
        if (frameSelects?.validateCustomColourSelection && !frameSelects.validateCustomColourSelection()) {
          this.handleErrorMessage('Choose a custom frame colour before adding this artwork to your cart.');
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        const customFrameAddOn = frameSelects?.getSelectedCustomFrameAddOn?.();
        const customFrameDetails = frameSelects?.getSelectedCustomFrameDetails?.();
        const sections = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        if (customFrameAddOn) {
          config.body = JSON.stringify(this.buildCustomFrameCartPayload(formData, customFrameAddOn, customFrameDetails, sections));
        } else {
          delete config.headers['Content-Type'];
          if (this.cart) {
            formData.append('sections', sections);
            formData.append('sections_url', window.location.pathname);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.items?.length) {
              response.id = response.items[0].id;
              response.key = response.items[0].key;
            }

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      getFrameSelects() {
        return this.closest('product-info')?.querySelector('frame-selects');
      }

      buildCustomFrameCartPayload(formData, customFrameAddOn, customFrameDetails, sections) {
        const quantity = Number(formData.get('quantity') || 1);
        const bundleId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        const productProperties = {};

        formData.forEach((value, key) => {
          const propertyMatch = key.match(/^properties\[(.+)\]$/);
          if (!propertyMatch || key === 'properties[Custom Frame Colour]' || key === 'properties[Frame Colour]') return;
          if (value !== '') productProperties[propertyMatch[1]] = value;
        });

        productProperties._FrameBundle = bundleId;
        if (customFrameDetails?.colourValue) productProperties._FrameColour = customFrameDetails.colourValue;

        const items = [
          {
            id: Number(formData.get('id')),
            quantity,
            properties: productProperties,
          },
          {
            id: Number(customFrameAddOn.variantId),
            quantity,
            properties: {
              _Addon: 'Custom frame colour',
              _AddonBundle: bundleId,
              _Frame: productProperties.Frame || '',
            },
          },
        ];

        return {
          items,
          sections,
          sections_url: window.location.pathname,
        };
      }
    }
  );
}
